'use client';

import * as React from 'react';
// import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
// import { Chart } from './chart';
import Chart from 'react-apexcharts';

function useChartOptions(xaxisOption, colors) {
  const theme = useTheme();

  return {
    chart: {
      toolbar: {
        show: false,
      },
      zoom: { enabled: false },
    },
    xaxis: {
      type: 'datetime',
      categories: xaxisOption,
      axisTicks: { color: theme.palette.divider, show: true },
      format: 'dd-MMM',
      min: new Date(xaxisOption[0]).getTime(), //
    },
    yaxis: {
      labels: {
        offsetX: -10,
        style: { colors: theme.palette.text.secondary },
      },
    },
    colors,
    theme: { mode: theme.palette.mode },
    fill: { opacity: 1, type: 'solid' },
    stroke: {
      curve: 'smooth', // Makes the line smooth
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    grid: {
      borderColor: theme.palette.divider,
      strokeDashArray: 2,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    markers: {
      size: 4, // Adds small circles at data points
    },
  };
}

const LineChartWidget = ({ title, xaxisOption, colors, chartSeries, sx }) => {
  const chartOptions = useChartOptions(xaxisOption, colors);

  return (
    <Card sx={sx}>
      <CardHeader title={title} />
      <CardContent>
        <Chart
          height={300}
          options={chartOptions}
          series={chartSeries}
          type="line"
          width="100%"
        />
      </CardContent>
      <Divider />
    </Card>
  );
};

LineChartWidget.propTypes = {
  title: PropTypes.string.isRequired,
  xaxisOption: PropTypes.array.isRequired,
  colors: PropTypes.array.isRequired,
  chartSeries: PropTypes.array.isRequired,
  sx: PropTypes.object,
};
LineChartWidget.defaultProps = {
  sx: {},
};

export default LineChartWidget;
